/*
* @Description: 水泥基准强度
* @Author: yjx
* @Date: 2021-11-19 18:22:22
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-28 16:13:39
*/
import request from '@/utils/request'
// 保存
export function saveStrength(data) {
  return request({
    url: '/icps/system/sign/basics/referencestrength/saveStrength',
    method: 'post',
    data
  })
}
// 列表
export function queryPage(data) {
  return request({
    url: '/icps/system/sign/basics/referencestrength/queryPage',
    method: 'post',
    data
  })
}
// 获取站点30天内水泥胶砂基准强度
export function queryOne(data) {
  return request({
    url: '/icps/system/sign/basics/referencestrength/queryOne',
    method: 'post',
    data
  })
}

